var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 14.6668H13.3333M9.18141 2.80345L3.52949 7.19939C3.15168 7.49324 2.96278 7.64017 2.82669 7.82417C2.70614 7.98716 2.61633 8.17078 2.56169 8.366C2.5 8.58639 2.5 8.8257 2.5 9.30433V15.3334C2.5 16.2669 2.5 16.7336 2.68166 17.0901C2.84144 17.4037 3.09641 17.6587 3.41002 17.8185C3.76654 18.0001 4.23325 18.0001 5.16667 18.0001H14.8333C15.7668 18.0001 16.2335 18.0001 16.59 17.8185C16.9036 17.6587 17.1586 17.4037 17.3183 17.0901C17.5 16.7336 17.5 16.2669 17.5 15.3334V9.30433C17.5 8.8257 17.5 8.58639 17.4383 8.366C17.3837 8.17078 17.2939 7.98716 17.1733 7.82417C17.0372 7.64017 16.8483 7.49324 16.4705 7.19939L10.8186 2.80345C10.5258 2.57574 10.3794 2.46189 10.2178 2.41812C10.0752 2.37951 9.92484 2.37951 9.78221 2.41812C9.62057 2.46189 9.47418 2.57574 9.18141 2.80345Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.21e1aa17ff5e2794db78757419015852.svg";
export { ForwardRef as ReactComponent };